import React, { Component } from 'react'
import { msToHMS } from '../../../utils/useful'

export default class AllVideos extends Component {
    state = {
        videoTime: 0,
    }
    videoEnded = () => {
        let videoTime = this.state.videoTime
        let videoPercentage = this.state.videoPercentage


        videoTime = null
        videoPercentage = null

        this.setState({ videoTime, videoPercentage, currentVideo: null })

    }
    render() {
        return (
            <div className='br-10 box-shadow-widgets'>
                <div style={{ height: '230px' }} className='br-10 position-relative flexcc video-container cursor-pointer'>
                    <video style={{ objectFit: 'cover' }} onEnded={() => this.videoEnded()} poster={this.props.data.cover} src={this.props.data.src} class="h-100 w-100 br-10" />
                    {!this.state.currentVideo && (
                        <div onClick={() => this.playVideo()} className="position-absolute top-0 left-0 flexcc w-100 h-100 radius-1">
                            <img className="play-icon" src="/images/icons/video-circle1.svg" height={90} />
                        </div>
                    )}
                    <p className="color-white br-6 py-1 px-2 position-absolute text-smallest" style={{ maxWidth: 60, bottom: '10px', right: '10px', backgroundColor: 'rgba(0,0,0,0.3)' }}>
                        {this.state.videoTime ? msToHMS(this.state.videoTime) : '00:00'}
                    </p>
                </div>
                <div className='py-1 mt-2 px-2 mb-1'>
                    <div className='flexcb mb-2'>
                        <div className='flexc'>
                            <div className='mrd-3' style={{ width: '35px', height: '35px', borderRadius: '100%', overflow: 'hidden' }}>
                                <img className='w-100 h-100 br-100' src="/images/video/vid3.jpg" alt="" />
                            </div>
                            <p className='fw-600'>{this.props.data.title}</p>
                        </div>
                    </div>
                    <div className="flexcb">
                        <p className='text-smallest'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur nam iusto explicabo velit odio delectus.</p>
                        {/* <img height="20px" src="/images/next-2.png" alt="" /> */}
                    </div>
                </div>
            </div>
        )
    }
}
